import React, { useEffect, useState } from "react";
import "../../assets/css/NewYear.css";

function NewYearLoader() {
  const [visibleText, setVisibleText] = useState("");

  useEffect(() => {
    const messages = [
      "Happy New Year 🎆",
      "Welcome 2026 🎇",
      "Cheers to New Beginnings 🥂",
    ];

    const text = messages[Math.floor(Math.random() * messages.length)];
    let index = 0;

    const interval = setInterval(() => {
      if (index < text.length) {
        setVisibleText((prev) => prev + text[index]);
        index++;
      } else {
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    document.body.style.overflow = "hidden";
  }, []);

  function handleLoad() {
    setTimeout(() => {
      const loader = document.getElementById("newYearLoader");
      if (loader) loader.style.display = "none";
      document.body.style.overflowY = "visible";
      const rootDiv = document.getElementById("root");
      if (rootDiv) rootDiv.style.display = "block";
    }, 4000);
  }

  return (
    <div
      id="newYearLoader"
      className="newyear-loader-container"
      onLoad={handleLoad}
    >
      {/* Sparkling Particles */}
      <div className="sparkles">
        {[...Array(80)].map((_, i) => (
          <div key={i} className="sparkle"></div>
        ))}
      </div>

      <div className="newyear-content">
        <h1 className="newyear-text">{visibleText}</h1>
        <p className="newyear-subtext">Wishing You Joy, Health & Prosperity</p>
      </div>
    </div>
  );
}

export default NewYearLoader;
